import { Pipe , PipeTransform  } from "@angular/core";

@Pipe({
    name: 'sortPipe'
})

export class Sort implements PipeTransform {
    transform(array: Array<string>, key: string): Array<string> {

        if(key === undefined || key == '' ){
            return array;
        }

        array.sort((a: any, b: any) => {
            return a[key].localeCompare(b[key])
        });

        return array;

    }

}



// WEBPACK FOOTER //
// ./src/pipes/sort/sort.ts